// Tara clientului dupa IP (Shopify), o singura cerere pe pagina. UE + UK = "eu" (TVA inclus, garantie legala,
// fara extra-uri bifate din start). Folosita de spark-product.js (caseta UE) si de cos (Shipping Protection).
window.SPARK_EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE GB'.split(' ');
window.sparkCountry = window.sparkCountry || fetch('/browsing_context_suggestions.json')
  .then(function (r) { return r.json(); })
  .then(function (d) { return (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || null; })
  .catch(function () { return null; });

(function () {
  // Timer cos: porneste la prima deschidere a paginii si continua intre pagini (sessionStorage).
  function tick() {
    var el = document.querySelector('[data-spark-timer]');
    if (!el) return;
    var total = +el.dataset.sparkTimer, end;
    try { end = +sessionStorage.getItem('sparkTimerEnd'); } catch (e) {}
    var now = Date.now();
    if (!end || end < now) { end = now + total * 1000; try { sessionStorage.setItem('sparkTimerEnd', end); } catch (e) {} }
    var left = Math.max(0, Math.round((end - now) / 1000));
    el.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
  }
  setInterval(tick, 1000); tick();
  // Cos: comutatoare pentru upsell si Shipping Protection (snippets/spark-cart-extras.liquid)
  var busy = false;
  function render(res) {
    var drawer = document.querySelector('cart-drawer');
    if (res && res.sections && drawer && drawer.renderContents) {
      drawer.renderContents(res);
      if (typeof res.item_count === 'number') drawer.classList.toggle('is-empty', res.item_count === 0);
    }
    return res;
  }
  function cartPost(url, body) {
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = window.location.pathname;
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(render);
  }
  function toggle(input, on) {
    if (busy) return Promise.resolve();
    busy = true;
    var kind = input.dataset.sparkToggle, props = {};
    props['_spark_' + kind] = '1';
    var req = on
      ? cartPost('cart/add.js', { items: [{ id: +input.dataset.variant, quantity: 1, properties: props }] })
      : cartPost('cart/change.js', { id: input.dataset.key, quantity: 0 });
    return req.catch(function () { input.checked = !on; }).finally(function () { busy = false; });
  }
  // captura: comutatorul nu mai ajunge la cart-items din Dawn (altfel il ia drept camp de cantitate si arata o eroare)
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-spark-toggle]');
    if (!input) return;
    e.stopPropagation();
    if (input.dataset.sparkToggle === 'protect') {
      try { input.checked ? sessionStorage.removeItem('spark-prot-off') : sessionStorage.setItem('spark-prot-off', '1'); } catch (er) {}
    }
    toggle(input, input.checked);
  }, true);

  // Stergere cu confirmare: primul click pe cosul de gunoi arata un buton rosu "Remove", al doilea sterge
  document.addEventListener('click', function (e) {
    var rb = e.target.closest && e.target.closest('#CartDrawer cart-remove-button');
    if (!rb || rb.dataset.armed === '1') return;
    e.preventDefault();
    e.stopPropagation();
    var row = rb.closest('.cart-item');
    rb.dataset.armed = '1';
    if (row) row.classList.add('spark-arm');
    setTimeout(function () { rb.dataset.armed = ''; if (row) row.classList.remove('spark-arm'); }, 4000);
  }, true);

  // Dupa fiecare schimbare in cos: daca nu mai e niciun produs principal, scoate si upsell-urile si protectia
  // (cosul ramane gol, cu buton spre prima pagina); altfel pune protectia daca e pornita din start.
  function cartCheck() {
    if (busy) return;
    var mk = document.querySelector('[data-spark-cart]');
    if (mk && +mk.dataset.main === 0 && mk.dataset.extra) {
      var updates = {};
      mk.dataset.extra.split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
      busy = true;
      cartPost('cart/update.js', { updates: updates }).finally(function () { busy = false; });
      return;
    }
    var p = document.querySelector('[data-spark-toggle="protect"]');
    if (!p) return;
    var off = false;
    try { off = sessionStorage.getItem('spark-prot-off') === '1'; } catch (er) {}
    if (+p.dataset.others > 0 && !p.checked && p.dataset.default === 'true' && !off) {
      // UE + UK: niciodata bifat din start (Directiva 2011/83 art. 22, UK CCR reg. 40)
      window.sparkCountry.then(function (cc) {
        if (!cc || window.SPARK_EU.indexOf(cc) > -1) return;
        if (!p.checked && !busy) toggle(p, true);
      });
    }
  }
  var cd = document.getElementById('CartDrawer'), t;
  if (cd) {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(cartCheck, 250); })
      .observe(cd, { childList: true, subtree: true });
    cartCheck();
  }

  // Buton urcare
  var b = document.querySelector('.spark-top');
  if (b) {
    window.addEventListener('scroll', function () {
      b.classList.toggle('is-on', window.scrollY > 800);
      // jos de tot, butonul urca peste randul cu platile, ca sa nu acopere politicile / Cookie preferences
      b.classList.toggle('is-end', window.innerHeight + window.scrollY > document.documentElement.scrollHeight - 140);
    }, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();
